import { useQuery } from '@apollo/client';
import { MOST_VISITED_COMPANIES_QUERY } from '@/graphql/queries';
import { MostVisitedCompaniesOrder } from '@/graphql/__generated__/graphql';

export const ORDERS = {
  RANDOM: MostVisitedCompaniesOrder.Random,
  VISITS_COUNT_DESC: MostVisitedCompaniesOrder.VisitsCountDesc,
};

type MostVisitedCompaniesProps = {
  limit: number;
  offset?: number;
};

const useMostVisitedCompanies = ({
  limit = 4,
  offset = 0,
}: MostVisitedCompaniesProps) => {
  const variables = {
    limit,
    offset,
    order: ORDERS.RANDOM,
  };
  const { error, ...rest } = useQuery(MOST_VISITED_COMPANIES_QUERY, {
    variables,
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
  });

  return {
    error,
    ...rest,
  };
};

export { useMostVisitedCompanies };
